module.exports = require("@fullcalendar/interaction");